import BreadCumb from "../../components/common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import backArrow from "../../assets/task/back_arrow.svg";
import AddSkill from "../../components/setting/AddSkill";
import AddPeerPoint from "../../components/setting/AddPeerPoint";

const AgencySetting = () => {
    const navigate = useNavigate()

    return (
        <>
            <div id="cts-respon-p-dv" className="w-full  relative  overflow-hidden flex flex-row items-start justify-center flex-wrap content-start py-40 px-20 mq991:p-8 mq575:p-4  box-border text-left text-base text-gray font-manrope">
                <div className="flex-1 flex flex-col items-start justify-start gap-6">
                    <BreadCumb />
                    <div className="self-stretch flex flex-row items-center justify-start gap-[5px] text-2xl">
                        <img className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img" alt="" src={backArrow}
                            onClick={() => navigate(-1)}
                        />
                        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit inline-block max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">Agency Settings</h3>
                    </div>
                    <div className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
                        <h5 className="my-0 text-xl-dv self-stretch relative text-lg">Peer Points Per Month</h5>
                        <AddPeerPoint />
                    </div>
                    <div className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
                        <h5 className="my-0 text-xl-dv self-stretch relative text-lg">Skills</h5>
                        <AddSkill />
                    </div>
                </div>
            </div >
        </>
    );
}

export default AgencySetting